import BigNumber from "bignumber.js";
import { roundNumber } from "./roundNumber";
import { expandRoundMode } from "./expandRoundMode";
var STORAGE_UNITS = ["byte", "kb", "mb", "gb", "tb", "pb", "eb"];
export function numberToHumanSize(i18n, input, options) {
  var roundMode = expandRoundMode(options.roundMode);
  var base = 1024;
  var num = new BigNumber(input).abs();
  var smallerThanBase = num.lt(base);
  var numberToBeFormatted;

  var computeExponent = function computeExponent(numeric, units) {
    var max = units.length - 1;
    var exp = new BigNumber(Math.log(numeric.toNumber())).div(Math.log(base)).integerValue(BigNumber.ROUND_DOWN).toNumber();
    return Math.min(max, exp);
  };

  var storageUnitKey = function storageUnitKey(units) {
    var keyEnd = smallerThanBase ? "byte" : units[exponent];
    return "number.human.storage_units.units.".concat(keyEnd);
  };

  var exponent = computeExponent(num, STORAGE_UNITS);

  if (smallerThanBase) {
    numberToBeFormatted = num.integerValue();
  } else {
    numberToBeFormatted = new BigNumber(roundNumber(num.div(Math.pow(base, exponent)), {
      significant: options.significant,
      precision: options.precision,
      roundMode: options.roundMode
    }));
  }

  var format = i18n.translate("number.human.storage_units.format", {
    defaultValue: "%n %u"
  });
  var unit = i18n.translate(storageUnitKey(STORAGE_UNITS), {
    count: num.integerValue().toNumber()
  });
  var formattedNumber = numberToBeFormatted.toFixed(options.precision, roundMode);

  if (options.stripInsignificantZeros) {
    formattedNumber = formattedNumber.replace(/(\..*?)0+$/, "$1").replace(/\.$/, "");
  }

  return format.replace("%n", formattedNumber).replace("%u", unit);
}